export var AuditResult;
(function (AuditResult) {
    AuditResult["SUCCESS"] = "success";
    AuditResult["FAILURE"] = "failure";
    AuditResult["DENIED"] = "denied";
})(AuditResult || (AuditResult = {}));
//# sourceMappingURL=audit-result.enum.js.map